module.exports = require("@gauzy/plugin-integration-ai");